module.exports = __webpack_public_path__ + "static/media/creamery.de301e9b.png";